define.alias("shared/helpers/get-attachment-url", "calendar/helpers/get-attachment-url");